import { Content, Header, HeaderLabel, InfoCard, Link, Page } from '@backstage/core-components';
import { Breadcrumbs, Grid, Typography } from '@material-ui/core';

const suggestions = (response: Response) => {
  switch (response.status) {
    case 504:
      return (
        <InfoCard>
          <Typography variant="h5">Recommendations</Typography>
          Please refresh the page. If the problem persists, contact us at #data-reliability.
        </InfoCard>
      );
    default:
      break;
  }
  return null;
};

export const BadResponse = ({ response }: { response: Response }) => {
  return (
    <Page themeId="tool">
      <Header
        title="Event Taxonomy Reference Data (ETRD)"
        subtitle="Streamline feature tracking with event taxonomy-related guidance"
      >
        <HeaderLabel label="Owner" value="Data Reliability" />
        <HeaderLabel label="Slack" value="#data-reliability" />
      </Header>
      <Content>
        <Grid direction="column" spacing={3} container>
          <Grid item>
            <Breadcrumbs>
              <Link to="/dr-event-taxonomy-reference-data">Home</Link>
            </Breadcrumbs>
          </Grid>
          <Grid item>{suggestions(response)}</Grid>
          <Grid item>
            <InfoCard>
              <Typography variant="h5">{response.statusText}</Typography>
              {response.body && response.body.toString()}
            </InfoCard>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
